/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_A3Inputs */

const en_cad_faq_a3 = /** @type {(inputs: Cad_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, in the desktop app. It opens DWG R13 through 2018 and reads DXF R12 through 2018 (ASCII and binary). It saves DXF and DWG in any version from 2000 to 2018 (2018 by default) and exports PDF, SVG and PNG. The online version also imports DWG locally in beta (up to 20 MB), then edits and saves a DXF copy. Entities it does not support yet are not kept on save, so keep a copy of your originals.`)
};

/**
* | output |
* | --- |
* | "Yes, in the desktop app. It opens DWG R13 through 2018 and reads DXF R12 through 2018 (ASCII and binary). It saves DXF and DWG in any version from 2000 to 20..." |
*
* @param {Cad_Faq_A3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_a3 = /** @type {((inputs?: Cad_Faq_A3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_A3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_a3(inputs)
});
export { cad_faq_a3 as "cad.faq.a3" }